import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AppConfigService } from '../../config/app.config.service';

/** Joins the app name to its tagline — the landing site's home-page format. */
const TAGLINE_SEPARATOR = ' — ';
/** Joins a route's own `title` to the app name, as the landing site does. */
const PAGE_SEPARATOR = ' · ';

/**
 * Browser tab title, read from the environment config (`app.name`,
 * `app.tagline`) instead of the static `<title>` in index.html, which now only
 * covers the moment before the app boots.
 *
 * `<name> — <tagline>` by default; a route that declares its own `title` gets
 * `<page> · <name>`.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly appConfig = inject(AppConfigService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const name = this.appConfig.appName;
    const page = this.buildTitle(snapshot);
    const tabTitle = page
      ? [page, name].filter(Boolean).join(PAGE_SEPARATOR)
      : [name, this.appConfig.appTagline].filter(Boolean).join(TAGLINE_SEPARATOR);
    // Nothing configured: keep index.html's title rather than blank the tab.
    if (tabTitle) {
      this.title.setTitle(tabTitle);
    }
  }
}
